import React from 'react'
import domecileMapImage from '/app/assets/images/domecile_map_request.png'

export default function RequestCanceled({ questionnaireRequest, propertyAddress, unitId, building_address }) {
  const goToDashboardList = () => (window.location = '/questionnaire_requests/list')
  const goToBuildingList = () => (window.location = '/buildings')

  const formatDate = () => {
    const isoString = questionnaireRequest.cancelled_at
    const date = new Date(isoString)
    const formatted =
      String(date.getMonth() + 1).padStart(2, '0') +
      '/' +
      String(date.getDate()).padStart(2, '0') +
      '/' +
      String(date.getFullYear()).slice(-2)
    return formatted
  }

  return (
    <div className="auto-questionnaire-processing-page-wrapper">
      <div className="auto-questionnaire-processing-page-container">
        <div className="dome-d-flex dome-align-start dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-gap6 dome-align-center">
            <span className="dome-h2 dome-color-dark-grey">questionnaire request</span>
            <span className="dome-p1 dome-color-dark-grey">
              #{questionnaireRequest.property_manager_id}-{questionnaireRequest.confirmation_id}
            </span>
          </div>
          <div style={{ background: 'white', borderRadius: 6, padding: 36 }}>
            <div style={{ width: 550 }}>
              <div className="dome-d-flex dome-flex-column dome-gap24">
                <div className="dome-d-flex dome-flex-column dome-gap18">
                  <span className="dome-h3 dome-color-red-alert">request canceled</span>
                  <span className="dome-p1 dome-color-dark-grey">
                    Your questionnaire request for the following property was canceled on {formatDate()}. If this was
                    done in error, simply initiate a new request.
                  </span>
                  <div
                    style={{
                      background: '#F9F9F9',
                      borderRadius: 6,
                      width: 'fit-content',
                      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.10)',
                    }}
                  >
                    <div className="dome-d-flex dome-align-center dome-gap12">
                      <img width={113} height={78} style={{ borderRadius: '6px' }} src={domecileMapImage} />
                      <div
                        style={{ width: 155, overflow: 'hidden' }}
                        className="dome-d-flex dome-flex-column dome-align-start dome-justify-center"
                      >
                        <span className="dome-p2 dome-color-dark-grey dome-full-width dome-overflow-ellipsis">
                          {propertyAddress}
                        </span>
                        <span className="dome-p2 dome-color-dark-grey dome-full-width dome-overflow-ellipsis">
                          {unitId}
                        </span>
                        <span className="dome-p2 dome-color-dark-grey dome-full-width dome-overflow-ellipsis">
                          {building_address.city}, {building_address.state}, {building_address.zip}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ height: '1px', background: '#F0F0F0', width: '100%' }}></div>
                <div className="dome-d-flex dome-justify-between">
                  <button
                    type="button"
                    onClick={goToDashboardList}
                    className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
                  >
                    back to dashboard
                  </button>
                  <button
                    type="button"
                    onClick={goToBuildingList}
                    className="dome-btn dome-btn-link dome-btn-link-aqua dome-btn-link-chevron-right"
                  >
                    start a new request
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
